module.exports = __webpack_public_path__ + "static/pillow-1-ow-dc78805aad3635f36aa24d6657c77f7f.webp";